export default "__VITE_ASSET__369b5250__"